
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Ganesha Utsava</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm ganesha-utsava section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>Ganesha<span > Utsava</span></h2>
            <p>India is a land of festival. It is a land of religious inclination. It is the land of cultural integrity.
            </p>
        </div>

        <div class="row mt-5">
            <div class="col-md-6">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/cult-2.webp" alt="GHRSCF">
                </div>
            </div>
            <div class="col-lg-6">
                <div class=" text-justify">
                    <div class="widget_title inner-title">
                        <h4>GANESHA UTSAVA</h4>
                    </div>
                    <div class="fide-chess-text">
                        <p>India is a land of festival. It is a land of religious inclination. It is the land of
                            cultural integrity. The festivals are celebrated round the country with immense fervor,
                            happiness, devotion and inclination. This is verbatim true for the festival, which
                            reciprocates- Jai Ganesha! Jai Ganesha!</p>
                    </div>
                    <p>
                        The name of the God Ganpati is taken before the start of every good work. Then, there is his
                        festival, which brings immense happiness, blessings and joy for his followers. It is really
                        fascinating how every nook and corner of the
                    </p>
                </div>
            </div>
            <div class="col-lg-12">
                <p>city, of almost all the states of the country celebrates the 9 day festival of Ganesha Chaturthi. The
                    Raisoni Group of Institutions too celebrates the festival with immense devotion, enthusiasm and
                    piousness. </p>
            </div>
        </div>
        <div class="widget_title inner-title">
            <h4>WHAT IS INCLUDED IN THE FESTIVAL OF GANESHA UTSAVA?
            </h4>
        </div>
        <ul class="list-style list-style1">
            <li>Ganesha Utsava marks the onset of the 9 day festival in the Raisoni Group of Institutions.</li>
            <li>The festival starts with the Sthapana of the idol of Lord Ganesha. </li>
            <li>It culminates with the Visarjana.</li>
        </ul>
        <ul class="list-style list-style1">
            <li><b>The Procession -</b> Imagine hundreds of students wearing colorful traditional attire involved in the
                procession of the Lord Ganesha to welcome him. The procession also has the faculty members and the non-
                teaching staff. And, then there is the decoration. The students and the staff members take care of the
                theme of the decoration and the rituals followed. </li>
            <li><b>The Execution -</b> From the minutest detail of making sure that the needful of the daily prayer is
                available to the conduction of the competitions at the campus- Each and every aspect is taken care of by
                the students and the staff together. Students have immense to learn in this process. The organization,
                the execution and the team building are some traits which the Vighnaharta- Lord Ganesha- teaches them
                through this festival. </li>
            <li><b>The Devotion -</b> the Aarti is conducted twice every day. The most appealing aspect is that the
                number of students which are present in the Aarti. Clad in traditional wear and singing the rhythmic
                "Sukhkarta Dukhharta…….." the entire environment seems to reciprocate with piousness. There is also the
                arrangement pursued of Daily Prasad in the morning and in the evening. </li>
            <li><b>The Events-</b> And, then each day marks a set of competitions in the respective campus. There are
                the technical, the cultural and the sports events held under which the students and staff members
                compete. A plethora of events are held under these 3 categories.</li>
            <li><b>The Visarjana-</b> Definitely, with so many blessings, fun and frolic it is tedious to precede for
                the Visarjana. Yet again, the same procession which welcomes the God to shower his blessings on us
                performs the requisite rituals for the Visarjana. There is that in- built faith in the devotees, of
                Bappa coming back next year that gives strength to them.</li>
        </ul>

        <h2 class="header_text">Jai Ganesha! Jai Ganesha!</h2>

        <div class="row  justify-content-center row-cols-1 row-cols-lg-2 align-items-center mt-5">
            <div class="col">
                <div class="feature-area">
                    <div class="feature-wrap">
                        <div class="single-feature">
                            <div class="title">
                                <h3>Go To Gallery <i class="fa fa-arrow-right blink" aria-hidden="true"></i></h3>
                            </div>
                        </div>
                        <a href="https://www.amazon.com/clouddrive/share/O8wH6jcsT5BITFK1lmGr7wkFrlSKeyM20KerHe6nOnP"
                            target="blank" class="feature-read-more">
                            View More
                            <i class="fa fa-arrow-right blink" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>


    </div>
</section>
